import { medialUrl } from "../../EndPoints";

import PoleStarFashionDesignImage from "../../assets/images/manufacturing/PoleStarFashionDesign.png";
import PoleStarKnitImage from "../../assets/images/manufacturing/PoleStarKnit.png";
import PrimeSweaterImage from "../../assets/images/manufacturing/PrmeSweater.png";
import BDKnitImage from "../../assets/images/manufacturing/BDKnitDesign.png";

import TruckImg from "../../assets/images/manufacturing/truck.png";
import SafetyImg from "../../assets/images/manufacturing/safety.png";
import MachineryImg from "../../assets/images/manufacturing/machinery.jpg";

import Machine1Image from "../../assets/images/manufacturing/machine1.png";
import Machine2Image from "../../assets/images/manufacturing/machine2.png";
import Machine3Image from "../../assets/images/manufacturing/machine3.png";

import AtlasLogo from "../../assets/images/manufacturing/logos/atlas.png";
import BrotherLogo from "../../assets/images/manufacturing/logos/brother.png";
import BryAirLogo from "../../assets/images/manufacturing/logos/bry-air.png";
import CintexLogo from "../../assets/images/manufacturing/logos/cintex.png";
import HashimaLogo from "../../assets/images/manufacturing/logos/hashima.png";
import JukiLogo from "../../assets/images/manufacturing/logos/juki.png";
import KannLogo from "../../assets/images/manufacturing/logos/kann.png";
import KansaiLogo from "../../assets/images/manufacturing/logos/kansai.png";
import KmLogo from "../../assets/images/manufacturing/logos/km.png";
import LectraLogo from "../../assets/images/manufacturing/logos/Lectra.png";
import NgaiLogo from "../../assets/images/manufacturing/logos/ngai.png";
import SchmidtLogo from "../../assets/images/manufacturing/logos/schmidt.png";
import SchrodersLogo from "../../assets/images/manufacturing/logos/schroders.png";
import VerivideLogo from "../../assets/images/manufacturing/logos/verivide.png";
import ZealLogo from "../../assets/images/manufacturing/logos/zeal.png";

export const heroManufactureImage = `${medialUrl}/img/manufacture/manu.jpeg`;

// Manufacturing
export const machinery1Image = MachineryImg;
export const machinery3Image = SafetyImg;
export const eastbalishmentImage = TruckImg;

export const MachineriesImages = [
  {
    image: Machine1Image,
    alt: "machine1",
  },
  { image: Machine2Image, alt: "machine2" },
  {
    image: Machine3Image,
    alt: "machine3",
  },
];

// FactoryBuilding

export const FactoryBuildingContent = [
  {
    src: PoleStarFashionDesignImage,
    title: "Pole Star Fashion Design Ltd.",
  },
  {
    src: PoleStarKnitImage,
    title: "Pole Star Knit Composite Ltd.",
  },
  {
    src: PrimeSweaterImage,
    title: "Prime Sweater",
  },
  {
    src: BDKnitImage,
    title: "BD Knit Design Ltd.",
  },
];

// Companies - Manufacture
export const companyLogos = [
  [JukiLogo, KansaiLogo, BrotherLogo, AtlasLogo, SchrodersLogo],
  [ZealLogo, BryAirLogo, CintexLogo, HashimaLogo, KannLogo],
  [KmLogo, NgaiLogo, LectraLogo, VerivideLogo, SchmidtLogo],
];
